import { Action, createReducer, on } from '@ngrx/store';
import { ProtocolModel } from '../models/protocol.model';
import * as protocolActions from './protocol.actions';

export const PROTOCOL_FEATURE_KEY = 'protocols';

export interface ProtocolState {
    protocols: ProtocolModel[];
    selectedProtocol: ProtocolModel | null;
    requestedProtocolId: number | null;
    loading: boolean;
    error: string | null;
    selectedHistory: ProtocolModel | null;
    historyProtocolId: number | null;
    historyId: number | null;
    historyLoading: boolean;
    historyError: string | null;
    count: number;
}

export const initialProtocolState: ProtocolState = {
    protocols: [],
    selectedProtocol: null,
    requestedProtocolId: null,
    loading: false,
    error: null,
    selectedHistory: null,
    historyProtocolId: null,
    historyId: null,
    historyLoading: false,
    historyError: null,
    count: 0
};

export const protocolReducer = createReducer(
    initialProtocolState,
    on(protocolActions.protocolSearchLoaded, (state, { protocols, count }) => ({ ...state, protocols, count })),
    on(protocolActions.protocolById, (state, { id }) => ({ ...state, requestedProtocolId: id, selectedProtocol: null, loading: true, error: null })),
    on(protocolActions.protocolByIdLoaded, (state, { data }) => state.requestedProtocolId === data.protocol.id
        ? { ...state, selectedProtocol: data.protocol, loading: false, error: null } : state),
    on(protocolActions.protocolByIdFailed, (state, { id, error }) => state.requestedProtocolId === id
        ? { ...state, selectedProtocol: null, loading: false, error } : state),
    on(protocolActions.protocolHistoryItem, (state, { protocolId, historyId }) => ({
        ...state, historyProtocolId: protocolId, historyId, selectedHistory: null, historyLoading: true, historyError: null
    })),
    on(protocolActions.protocolHistoryItemLoaded, (state, { protocolId, historyId, history }) =>
        state.historyProtocolId === protocolId && state.historyId === historyId && history.id === protocolId && history.protocolHistoryId === historyId
            ? { ...state, selectedHistory: history, historyLoading: false, historyError: null } : state),
    on(protocolActions.protocolHistoryItemFailed, (state, { protocolId, historyId, error }) =>
        state.historyProtocolId === protocolId && state.historyId === historyId
            ? { ...state, selectedHistory: null, historyLoading: false, historyError: error } : state),
    on(protocolActions.protocolCreateLoaded, (state, action) => ({ ...state, selectedProtocol: action.data.protocol })),
    on(protocolActions.protocolUpdateLoaded, (state, action) => state.requestedProtocolId === action.data.protocol.id
        ? { ...state, selectedProtocol: action.data.protocol } : state)
);

export const reducer = (state: ProtocolState, action: Action) => protocolReducer(state, action);
